import { render, staticRenderFns } from "./Detail6.vue?vue&type=template&id=39568f54&scoped=true&"
import script from "./Detail6.vue?vue&type=script&lang=js&"
export * from "./Detail6.vue?vue&type=script&lang=js&"
import style0 from "./Detail6.vue?vue&type=style&index=0&id=39568f54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39568f54",
  null
  
)

export default component.exports